import { createWebSocketStore } from 'src/components/#services/helpers';
export const buySpin = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'shop',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'spin_buySpin',
    },
});
export const getSpinHistory = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'shop',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'spin_getAllMy',
    },
});
